/* after changing this file run 'yarn run webpack:build' */
/* tslint:disable */
import '../assets/scss/vendor.scss';

// Imports all fontawesome core and solid icons

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEllipsisV,
  faUser,
  faSort,
  faSync,
  faEye,
  faEyeSlash,
  faBan,
  faTimes,
  faArrowLeft,
  faArrowRight,
  faSave,
  faPlus,
  faMinus,
  faPencilAlt,
  faBars,
  faThList,
  faUserPlus,
  faRoad,
  faTachometerAlt,
  faHeart,
  faList,
  faBell,
  faBook,
  faHdd,
  faFlag,
  faWrench,
  faClock,
  faCloud,
  faSignOutAlt,
  faSignInAlt,
  faCalendarAlt,
  faSearch,
  faTrashAlt,
  faAsterisk,
  faTasks,
  faHome,
  faHistory,
  faInfoCircle,
  faCheck,
  faChevronDown,
  faChevronUp,
  faWindowClose,
  faDownload,
  faFile
} from "@fortawesome/free-solid-svg-icons";

// Adds the SVG icon to the library so you can use it in your page
library.add(faUser);
library.add(faSort);
library.add(faSync);
library.add(faEye);
library.add(faEyeSlash);
library.add(faBan);
library.add(faTimes);
library.add(faArrowLeft);
library.add(faArrowRight);
library.add(faSave);
library.add(faPlus);
library.add(faMinus);
library.add(faPencilAlt);
library.add(faBars);
library.add(faHome);
library.add(faThList);
library.add(faUserPlus);
library.add(faRoad);
library.add(faTachometerAlt);
library.add(faHeart);
library.add(faList);
library.add(faBell);
library.add(faTasks);
library.add(faBook);
library.add(faHdd);
library.add(faFlag);
library.add(faWrench);
library.add(faClock);
library.add(faCloud);
library.add(faSignOutAlt);
library.add(faSignInAlt);
library.add(faCalendarAlt);
library.add(faSearch);
library.add(faTrashAlt);
library.add(faAsterisk);
library.add(faHistory);
library.add(faInfoCircle);
library.add(faCheck);
library.add(faEllipsisV);
library.add(faChevronDown);
library.add(faChevronUp);
library.add(faWindowClose);
library.add(faDownload);
library.add(faFile);

// jhipster-needle-add-element-to-vendor - JHipster will add new menu items here
